import { customFetch } from '#/services/customFetch'
import type { PricingTableResponse } from '../types/plan.types'

export async function getPlans(): Promise<PricingTableResponse> {
  return customFetch<PricingTableResponse>('/student/plans')
}
